import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admission-in-bba',
  templateUrl: './admission-in-bba.component.html',
  styleUrls: ['./admission-in-bba.component.scss']
})
export class AdmissionInBBAComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
